$(document).ready(function() {
  if ($('.home-page').length > 0) {

    function bind() {
      handleScrollOnLoad();
      handleScrollDots();
      handleLoader();
      handleSignUpModal();
      handleRemoveErrorMessages();
    }
    bind();

    function handleScrollDots() {
      $(window).on('scroll', function () {
        let currentScroll = $(this).scrollTop();
        let currentSection = '';

        $('section').each(function () {
          let sectionTop = $(this).offset().top;

          if (currentScroll >= sectionTop - 100) {
            currentSection = $(this).attr('id');
          }
        });

        let scrollDots = $('.scroll-dots a');
        scrollDots.removeClass('active');

        scrollDots.each(function () {
          if ($(this).attr('href') === `#${currentSection}`) {
            $(this).addClass('active');
          }
        });
      });

      $(document).on('click', '.scroll-dots a', function(e) {
        e.preventDefault();
        let targetSection = $(this).attr('href');

        $('html, body').animate({
          scrollTop: $(targetSection).offset().top
        }, 400);
      })
    }

    function handleScrollOnLoad() {
      window.history.scrollRestoration = "manual";

      $(window).on('load', function() {
        $(this).scrollTop(0);
      });
    }

    function handleLoader() {
      let body = $('body');
      let loader = $('.home-page-loader');
      let heroSection = $('#hero');

      body.addClass('overflow-y-hidden');

      setTimeout(function() {
        loader.addClass('d-none');
        heroSection.addClass('start-animation');
        body.removeClass('overflow-y-hidden');
      }, 2400);
    }

    function handleRemoveErrorMessages() {
      $(document).on('input', '.field-inputs', function(e) {
        let parent = $(this).parent();
        parent.find('.form-submit-error-messages').remove();
      });
    }

    function handleSignUpModal() {
      $(document).on('click', '#open-apply-modal', function() {
        $('#club-apply-modal').modal('show');
      });

      $(document).on('click', '#club-apply-button', function(e) {
        e.preventDefault();

        if (!validateClubApplyForm()) {
          return;
        }

        let form = $('#clubApplyForm');
        let formData = new FormData(form.get(0));

        $.ajax({
          url: form.attr('action'),
          method: form.attr('method'),
          headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),},
          data: formData,
          processData: false,
          contentType: false,
          success: function(result) {
            let clubApplyModal = $('#club-apply-modal');
            clubApplyModal.modal('hide');
            clubApplyModal.find('#name').val('');
            clubApplyModal.find('#club').val('');
            clubApplyModal.find('#email').val('');
            clubApplyModal.find('#phone').val('');
            clubApplyModal.find('#message').val('');

            Swal.fire({
              title: "Your request has been sent!",
              icon: "success",
              customClass:{
                popup: "successMessageSwalHome"
              },
            });
          },
          error: function(xhr, status, error) {
            $('#club-apply-modal').modal('hide');

            Swal.fire({
              title: "Error!",
              text: xhr.responseJSON.message,
              icon: "error",
              customClass:{
                popup: "errorMessageSwal"
              },
            });
          }
        });
      });
    }

    function validateClubApplyForm() {
      $('.form-submit-error-messages').remove();

      let notFilled = false;

      let clubName = $('#club');
      let fullName = $('#name');
      let phone = $('#phone');
      let email = $('#email');

      if (clubName.val().trim() === '') {
        notFilled = true;
        addErrorMessages('Club name is required.', clubName);
      }

      if (fullName.val().trim() === '') {
        notFilled = true;
        addErrorMessages('Your name is required.', fullName);
      }

      if (email.val().trim() === '') {
        notFilled = true;
        addErrorMessages('Wrong email address.', email);
      }

      let phoneString = phone.val().trim();
      let phoneRegex = /^\+?[0-9]+$/;
      if (phoneString === '' || !phoneRegex.test(phoneString)) {
        notFilled = true;
        addErrorMessages('Wrong phone number.', phone);
      }

      return !notFilled;
    }

    function addErrorMessages(message, selector) {
      let html = `<div class="form-submit-error-messages pt-2 pl-2">${message}</div>`;
      selector.parent().append(html);
    }
  }
});
